import clsx from 'clsx';

export function EditCard({ onClick, className, children }) {
  return (
    <div
      className="relative py-5 before:absolute before:top-0 before:bottom-0 before:left-[-99999px] before:right-[-99999px] before:bg-gray-100"
      data-testid="edit-card"
    >
      <article
        className={clsx(
          'group relative flex items-center justify-stretch min-h-[90px] py-2.5 px-4 border border-300 rounded-lg bg-white shadow-sm font-normal text-body-dark transition-colors hover:bg-primary-50 hover:border-primary',
          className,
        )}
        role="button"
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.(e);
          }
        }}
        tabIndex={0}
      >
        <div className="grow">{children}</div>
        <div className="size-11 flex items-center justify-center" aria-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-gray-500 transition-colors group-hover:stroke-primary"
          >
            <path
              d="M11 5H6C4.89543 5 4 5.89543 4 7V18C4 19.1046 4.89543 20 6 20H17C18.1046 20 19 19.1046 19 18V13M17.5858 3.58579C18.3668 2.80474 19.6332 2.80474 20.4142 3.58579C21.1953 4.36683 21.1953 5.63316 20.4142 6.41421L11.8284 15H9L9 12.1716L17.5858 3.58579Z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </article>
    </div>
  );
}
